import {FC} from 'react'
import OTPInput from 'react-otp-input'

const CustomOtpInput: FC<{
  label: string
  otp: string
  error: boolean
  className?: string
  separatorClassName?: string
  handleOTPChange: (otp: string) => void
  onEnterPress?: () => void
  enableEnterKeySubmit?: boolean
}> = ({
  otp,
  label,
  error,
  className,
  handleOTPChange,
  separatorClassName,
  onEnterPress,
  enableEnterKeySubmit = false,
}) => {
  return (
    <OTPInput
      value={otp}
      onChange={(otp: any) => {
        handleOTPChange(otp)
      }}
      shouldAutoFocus={true}
      inputType='number'
      numInputs={6}
      containerStyle={`${error && 'otp-error-border'} ${className}`}
      renderSeparator={<span className={separatorClassName}></span>}
      renderInput={(props: any) => (
        <input
          id={label}
          {...props}
          autoComplete='off'
          type='text'
          inputMode='text'
          onKeyDown={(e) => {
            if (enableEnterKeySubmit && e.key === 'Enter' && otp.length === 6 && onEnterPress) {
              onEnterPress()
            }
          }}
        />
      )}
    />
  )
}

export {CustomOtpInput}
